import React from 'react';
import './TestiMonials.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css';


const TestiMonials = () => {
  const testimonials = [
    {
      id: 1,
      name: "—  NIKHIL RAJ, Customer",
      description:
        "The LMV Insurance platform made buying my health insurance so easy! The comparison feature helped me pick the best plan, and the claim process was hassle-free.",
      photo:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0khaUcbpblqXKUuxIpxyGB9VqRKmENQZWjbk8uXGEIg&s",
    },
    {
      id: 2,
      name: "— DRISHYA K, Certified POSP Agent",
      description:
        "LMV Insurance CRM has transformed my business! The easy policy comparisons and commission tracking make selling insurance effortless.",
      photo:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0khaUcbpblqXKUuxIpxyGB9VqRKmENQZWjbk8uXGEIg&s",
    },
    {
      id: 3,
      name: "— Punarjani Motors, MISP Partner",
      description:
        "Managing motor insurance policies has never been easier! LMV Insurance simplifies policy issuance and keeps my commissions transparent.",
      photo:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0khaUcbpblqXKUuxIpxyGB9VqRKmENQZWjbk8uXGEIg&s",
    },
    {
      id: 4,
      name: "— Magma General Insurance",
      description:
        "Partnering with LMV Insurance has helped us reach more customers efficiently. Their seamless integration and transparent commission system are outstanding!",
      photo:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0khaUcbpblqXKUuxIpxyGB9VqRKmENQZWjbk8uXGEIg&s",
    },
    {
      id: 5,
      name: "— ROOPA, Happy Customer",
      description:
        "I was hesitant about buying insurance online, but LMV Insurance made it so simple. The step-by-step process and expert support helped me find the right coverage for my family. Highly recommended!",
      photo:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0khaUcbpblqXKUuxIpxyGB9VqRKmENQZWjbk8uXGEIg&s",
    },
    {
      id: 6,
      name: "— HEMA V, Certified POSP Partner",
      description:
        "As an independent insurance agent, I needed a platform that simplifies policy selling and commission tracking. LMV Insurance CRM gives me real-time insights, automated renewals, and a seamless dashboard—making my work so much easier!",
      photo:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0khaUcbpblqXKUuxIpxyGB9VqRKmENQZWjbk8uXGEIg&s",
    },
    {
      id: 7,
      name: "— IFFCO TOKIO General Insurance",
      description:
        "Working with LMV Insurance has streamlined our policy distribution. Their system ensures transparency in commissions, real-time reporting, and excellent customer engagement. A great platform for insurance providers!",
      photo:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0khaUcbpblqXKUuxIpxyGB9VqRKmENQZWjbk8uXGEIg&s",
    },
    // Add more testimonials as needed
  ];

  const settings = {
    dots: true,
    centerMode: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    pauseOnHover: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };


  return (
    <div className='testimonial-section'>
    <Slider {...settings}>
      {testimonials.map(testimonial => (
        <div key={testimonial.id}>
          <div className="testimonial-card">
            {/* <img src={testimonial.photo} alt={testimonial.name} className="testimonial-photo" /> */}
            <p className="testimonial-description">{testimonial.description}</p>
            <p className="testimonial-name">{testimonial.name}</p>
          </div>
        </div>
      ))}
    </Slider>
    </div>
  );
};

export default TestiMonials;
  